export const appName = "SNAPPY";
// export const defaultBackgroundColor = "#131324";